export const accessAllFacilityFeatures = 'user can switch mode to see all facility features';
export const importSaasPatientId = 'user can import saas patient id';
export const addPatientManually = 'user can add patient manually';
